import filter from 'lodash/filter'
import map from 'lodash/map'
import { IApplicationState } from '@Site/rootReducer'

import { createSelector } from 'reselect'

import {
  IGuideline,
} from './types'

export const getGuidelines = (state: IApplicationState): IGuideline[] => state.guidelines.guidelines
export const getGuidelinesLoading = (state: IApplicationState): boolean => state.guidelines.loading
export const getGuidelinesHasLoadedInitially = (state: IApplicationState): boolean => state.guidelines.hasLoadedInitially

export const getCaptionGuidelines = createSelector(
  [getGuidelines],
  (guidelines) => filter(guidelines, guideline => guideline.attributes.category === 'caption')
)

export const getTranslationGuidelines = createSelector(
  [getGuidelines],
  (guidelines) => filter(guidelines, guideline => guideline.attributes.category === 'translation')
)

export const getCaptionGuidelineNames = createSelector(
  [getCaptionGuidelines],
  (captionGuidelines) => map(captionGuidelines, captionGuideline => captionGuideline.attributes.name)
)

export const getCaptionGuidelineIds = createSelector(
  [getCaptionGuidelines],
  (captionGuidelines) => map(captionGuidelines, captionGuideline => captionGuideline.id)
)

export const getTranslationGuidelineNames = createSelector(
  [getTranslationGuidelines],
  (translationGuidelines) => map(translationGuidelines, translationGuideline => translationGuideline.attributes.name)
)

export const getTranslationGuidelineIds = createSelector(
  [getTranslationGuidelines],
  (translationGuidelines) => map(translationGuidelines, translationGuideline => translationGuideline.id)
)
